const CommentsForm = {
	new_comment: 'Novo Comentário',
	name: 'Nome (opcional)',
	submit: 'Enviar'
}

export default CommentsForm;